var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8242 20.106C11.3422 20.683 12.0072 21 12.6972 21H12.6982C13.3912 21 14.0592 20.683 14.5782 20.105C14.8562 19.798 15.3302 19.773 15.6372 20.05C15.9452 20.327 15.9702 20.802 15.6932 21.109C14.8852 22.006 13.8222 22.5 12.6982 22.5H12.6962C11.5752 22.499 10.5142 22.005 9.70923 21.108C9.43223 20.801 9.45723 20.326 9.76523 20.05C10.0732 19.772 10.5472 19.797 10.8242 20.106ZM12.747 1C17.192 1 20.178 4.462 20.178 7.695C20.178 9.358 20.601 10.063 21.05 10.811C21.494 11.549 21.997 12.387 21.997 13.971C21.648 18.018 17.423 18.348 12.747 18.348C8.07103 18.348 3.84503 18.018 3.50001 14.035C3.49703 12.387 4.00003 11.549 4.44403 10.811L4.60077 10.5472C4.9867 9.88386 5.31603 9.16235 5.31603 7.695C5.31603 4.462 8.30203 1 12.747 1ZM12.747 2.5C9.25203 2.5 6.81603 5.238 6.81603 7.695C6.81603 9.774 6.23903 10.735 5.72903 11.583C5.32003 12.264 4.99703 12.802 4.99703 13.971C5.16403 15.857 6.40903 16.848 12.747 16.848C19.05 16.848 20.334 15.813 20.5 13.906C20.497 12.802 20.174 12.264 19.765 11.583C19.255 10.735 18.678 9.774 18.678 7.695C18.678 5.238 16.242 2.5 12.747 2.5Z",
    fill: "#1F2C37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.ed6b44125a460c2940063f4f5a1e4405.svg";
export { ForwardRef as ReactComponent };